module.exports = __webpack_public_path__ + "img/thumbnail_CloudedLeopard_j_normal.7a377b1b.png";